import { ModulePlaceholder } from "@/components/modules/ModulePlaceholder";

const Build = () => {
  return <ModulePlaceholder moduleKey="build" />;
};

export default Build;
